import { useEffect, useState } from "react";
import { PillType } from "../Pill";
import { EnvironmentType } from "./types";
const indicatorValues = {
    default: {
        colorProperty: "--palette-primary-100",
        pillType: PillType.Info,
    },
    [EnvironmentType.Formation]: {
        colorProperty: "--palette-primary-100",
        pillType: PillType.Info,
    },
    [EnvironmentType.Internal]: {
        colorProperty: "--palette-secondary-100",
        pillType: PillType.Secondary,
    },
    [EnvironmentType.Preproduction]: {
        colorProperty: "--palette-warning-100",
        pillType: PillType.Warning,
    },
    [EnvironmentType.Production]: {},
    [EnvironmentType.Test]: {
        colorProperty: "--palette-error-100",
        pillType: PillType.Danger,
    },
};
export const useEnvironmentIndicator = (environment) => {
    const [color, setColor] = useState();
    const { colorProperty, pillType } = indicatorValues[environment || "default"];
    useEffect(() => {
        setColor(colorProperty && getComputedStyle(document.documentElement).getPropertyValue(colorProperty));
    }, [colorProperty]);
    return {
        color,
        colorProperty,
        pillType,
    };
};
//# sourceMappingURL=useEnvironmentIndicator.js.map